module.exports = __webpack_public_path__ + "img/team-bramfeldersv@2x.3475ee52.jpg";